import classNames from "classnames";
import React from "react";
import { deepEqual } from "../deep-equal";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppCard, AppCardContent } from "./Generic/AppCard";
import { If } from "./Generic/If";
import QuestionHeader from "./QuestionHeader";
import RequiredDocReadonlyAnswer from "./RequiredDocReadonlyAnswer";
import { ReqDocAnswerableQuestionMulti } from "./ScheduledVisitDocScreen";
import { scrollToViewAfterKeyboardOpen } from "./ScheduledVisitDocScreenUtils";

export class RequiredDocRadio extends React.Component<
  ReqDocAnswerableQuestionMulti,
  { otherVal: string; suppHash: string }
> {
  constructor(props: ReqDocAnswerableQuestionMulti) {
    super(props);

    const randomHash = Math.random().toString(36).substring(7);

    this.state = {
      otherVal: this.isOtherChecked() ? (props.currentAnswer as string) : "",
      suppHash: randomHash,
    };
  }

  shouldComponentUpdate(nextProps: ReqDocAnswerableQuestionMulti, nextState: { otherVal: string }) {
    return !deepEqual(this.props, nextProps) || !deepEqual(this.state, nextState);
  }

  changeOtherVal(val: string) {
    this.setState({
      ...this.state,
      otherVal: val,
    });
    this.props.handleOnInsertAnswer(this.props.questionId, val);
  }

  answerInPossibleAnswers(val: string) {
    for (const answer of this.props.possibleAnswers) {
      if (answer.toLowerCase() === val.toLowerCase()) {
        return true;
      }
    }
    return false;
  }

  isOtherChecked() {
    if (this.props.currentAnswer === null || this.props.currentAnswer === undefined) {
      return false;
    }

    for (const answer of this.props.possibleAnswers) {
      if (answer.toLowerCase() === (this.props.currentAnswer as string).toLowerCase()) {
        return false;
      }
    }

    return true;
  }

  renderOtherOption() {
    const checked = this.isOtherChecked();
    return (
      <div key={this.props.possibleAnswers.length}>
        <div className="ScheduledVisitDocScreen__radioButton radio-button radio-button--material">
          <input
            className="radio-button__input radio-button--material__input"
            type="radio"
            name={`${this.props.questionId.toString()}${this.state.suppHash}`}
            disabled={this.props.readonly}
            onChange={() => {
              this.changeOtherVal(
                this.answerInPossibleAnswers(this.state.otherVal) ? "" : this.state.otherVal
              );
            }}
            value={this.state.otherVal}
            checked={checked}
          />
          <div className="radio-button__checkmark radio-button--material__checkmark" />
          Other
        </div>
        <If condition={checked}>
          <div onClick={(e) => scrollToViewAfterKeyboardOpen(e)}>
            <input
              placeholder={translate(STRINGS.ENTER_TEXT_HERE)}
              className="ScheduledVisitDocScreen__block text-input text-input--material"
              disabled={this.props.readonly}
              onChange={(event: any) => {
                this.changeOtherVal(event.target.value);
              }}
              value={this.props.currentAnswer === null ? "" : this.props.currentAnswer}
            />
          </div>
        </If>
      </div>
    );
  }

  handleOnInsertAnswer(value: string) {
    if (!this.props.readonly) {
      this.props.handleOnInsertAnswer(this.props.questionId, value);
    }
  }

  handleAppCardClick() {
    if (this.props.readonly && this.props.onClickWhileDisabled !== undefined) {
      this.props.onClickWhileDisabled();
    }
  }

  render() {
    return (
      <AppCard
        className={classNames({ __invalid: !this.props.isValid })}
        onClick={() => this.handleAppCardClick()}
      >
        <QuestionHeader
          text={this.props.questionText}
          isRequired={this.props.isRequired}
          notes={this.props.notes}
          isReadonly={this.props.readonly}
        />
        <AppCardContent>
          {this.props.readonly ? (
            <RequiredDocReadonlyAnswer currentAnswer={this.props.currentAnswer} />
          ) : (
            <>
              {this.props.possibleAnswers.map((val, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => this.handleOnInsertAnswer(val)}
                    className="ScheduledVisitDocScreen__radioButton asd adio-button radio-button--material"
                  >
                    <input
                      className="radio-button__input radio-button--material__input"
                      type="radio"
                      name={`${this.props.questionId.toString()}${this.state.suppHash}`}
                      value={val}
                      disabled={this.props.readonly}
                      defaultChecked={
                        this.props.currentAnswer === null || this.props.currentAnswer === undefined
                          ? false
                          : (this.props.currentAnswer as string).toLowerCase() === val.toLowerCase()
                      }
                    />
                    <div className="radio-button__checkmark radio-button--material__checkmark" />
                    {val}
                  </div>
                );
              })}
              {this.props.showOtherOption ? this.renderOtherOption() : null}
            </>
          )}
        </AppCardContent>
      </AppCard>
    );
  }
}
